"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _Icon = _interopRequireDefault(require("../Icon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var Search = function Search(props) {
  var value = props.value,
    placeholder = props.placeholder,
    defaultValue = props.defaultValue,
    _props$onSearch = props.onSearch,
    onSearch = _props$onSearch === void 0 ? function (arg) {} : _props$onSearch,
    _props$isActive = props.isActive,
    isActive = _props$isActive === void 0 ? false : _props$isActive;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('nav');
  var searchRef = (0, _react.useRef)(null);
  var _React$useState = _react.default.useState(value === undefined ? defaultValue : value),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    searchVal = _React$useState2[0],
    setSearchVal = _React$useState2[1];
  (0, _react.useEffect)(function () {
    if (!isActive) {
      setSearchVal('');
    }
  }, [isActive]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__search-box")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__search"),
    ref: searchRef
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__search-bar")
  }, /*#__PURE__*/_react.default.createElement("input", {
    value: searchVal,
    type: "text",
    className: "".concat(prefixCls, "__search-input"),
    placeholder: placeholder
    //    onFocus={() => setVisible(true)}
    ,
    onChange: function onChange(e) {
      return setSearchVal(e.target.value);
    },
    onBlur: function onBlur(e) {
      setSearchVal(e.target.value);
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') {
        onSearch(searchVal);
      }
    }
  }), /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick() {
      return onSearch(searchVal);
    },
    className: "".concat(prefixCls, "__search-btn")
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "search",
    color: "#00000066"
  })))));
};
var _default = exports.default = Search;